<template>
    <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
        <b-row>
            <b-col cols="" class="">
                <b-row>
                    <b-col cols="">
                        <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                            <h2 class="text-left mb-0">{{ $t('maintenanceLineItems.title') }}</h2>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <div class="data-table team-data-table pt-3 pt-sm-4 bg-white rounded table-custom-border">
                            <div class="table_row team_table_row">
                                <div class="equipment-border filter-box" v-if="isTableMounted">
                                        <div class="d-flex mb-0 px-3 px-sm-4 flex-wrap gap-2">
                                        <b-form-group :label="$t('reportsCommon.selectDate')" class="text-left  report-datepicker">
                                            <date-picker v-model="filterFields.date" :formatter="momentFormat"
                                                @change="getTableData()" :range-separator="' - '"
                                                @clear="filterFields.date = ''" range
                                                class="date-picker-custom f-12" :shortcuts="shortcuts"></date-picker>
                                        </b-form-group>
                                        <b-form-group :label="$t('reportsCommon.selectUnits')" class="text-left report-fields ">
                                            <v-select multiple :options="allUnits" class="f-12"
                                                :reduce="(option) => option.id" v-model="filterFields.units"
                                                @input="getTableData()" @search="searchUnits" />
                                        </b-form-group>
                                        <b-form-group :label="$t('reportsCommon.selectTags')" class="text-left report-fields ">
                                            <v-select multiple :options="allTags" class="f-12"
                                                :reduce="(option) => option.id" v-model="filterFields.tags"
                                                @input="getTableData()" />
                                        </b-form-group>
                                        <b-form-group :label="$t('maintenanceLineItems.selectCategories')" class="text-left report-fields ">
                                            <v-select multiple :options="filtersData && filtersData.categories ? filtersData.categories.map((item) => {
                                                return {
                                                    id: item.label,
                                                    label: item.label
                                                }
                                            }) : []" class="f-12" :reduce="(option) => option.id"
                                                v-model="filterFields.categories"
                                                @input="getTableData()" />
                                        </b-form-group>
                                        <b-form-group :label="$t('maintenanceLineItems.selectItemTypes')" class="text-left report-fields ">
                                            <v-select multiple :options="filtersData && filtersData.item_types ? filtersData.item_types.map((item) => {
                                                return {
                                                    id: item.key,
                                                    label: item.label
                                                }
                                            }) : []" class="f-12" :reduce="(option) => option.id"
                                                v-model="filterFields.item_types"
                                                @input="getTableData()" />
                                        </b-form-group>
                                    </div>
                                </div>
                                <div v-if="!isTableMounted" class="mt-2"
                                    style="height: calc(100vh - 165px); overflow: hidden;">
                                    <b-skeleton-table :rows="17" :columns="7"
                                        :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                </div>
                                <b-table v-else class="mt-2" responsive :fields="translatedFields" :items="items" hover
                                    :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                    :no-local-sorting="true" :busy.sync="isBusy" :sticky-header="'calc(100vh - 300px)'" :show-empty="emptyTable">
                                    <template #cell(tags)="data">
                                        <div v-if="data.value.length" class="d-flex align-items-center">
                                            <div class="table-tags mr-2">{{ data.value[0] }}</div>
                                            <v-app>
                                                <v-tooltip bottom v-if="data.value.length > 1">
                                                    <template #activator="{ on, attrs }">
                                                        <div class="table-tags" v-on="on" v-bind="attrs">+{{
                                                            data.value.length - 1 }}</div>
                                                    </template> <span v-html="data.value.slice(1).join('<br>')"></span>
                                                </v-tooltip>
                                            </v-app>
                                        </div>
                                        <p class="mb-0" v-else>-</p>
                                    </template>
                                    <template #cell(description)="data">
                                        <v-app v-if="data.value && data.value !== 'null'">
                                            <v-tooltip top>
                                                <template #activator="{ on, attrs }">
                                                    <span class="w-fit-content item-description text-left mw-400px"
                                                        v-on="on" v-bind="attrs">{{
                                                            data.value }}</span>
                                                </template>{{ formatTooltipText(data.value) }}
                                            </v-tooltip>
                                        </v-app>
                                        <p v-else>-</p>
                                    </template>
                                    <template v-slot:custom-foot
                                        v-if="translatedFields.filter((item) => item.key === 'amount').length">
                                        <tr class="sticky-footer">
                                            <td v-for="(field, index) in translatedFields" :key="index">
                                                <span v-if="field.key === 'amount'" class="font-weight-bold">{{ totalAmount
                                                    ?
                                                    `$${getAmount(totalAmount)}` : "-" }}</span>
                                            </td>
                                        </tr>
                                    </template>
                                </b-table>
                                <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
                                    <div class="d-flex align-items-center flex-wrap">
                                        <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                            <b-form-select v-model="perPage" :options="pageOptions" />
                                        </div>
                                        <div class="pagination">
                                            <b-pagination v-model="currentPage" :total-rows="rows"
                                                :per-page="perPage"></b-pagination>
                                        </div>
                                        <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex"
import DatePicker from 'vue2-datepicker';
import * as moment from "moment-timezone";
import 'vue2-datepicker/index.css';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    name: "MaintenanceLineItems",
    components: {
        DatePicker,
        vSelect,
    },
    data() {
        return {
            positionText: '',
            totalAmount: 0,
            filtersData: null,
            momentFormat: {
                //[optional] Date to String
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                //[optional]  String to Date
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            items: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            sortBy: '',
            sortDesc: false,
            isBusy: false,
            isTableMounted: false,
            emptyTable: false,
            rows: 0,
            filterFields: {
                search: '',
                date: '',
                record_no: '',
                categories: [],
                units: [],
                tags: [],
                item_types: []
            },
            allTags: [],
            allUnits: []
        }
    },
    computed: {
        ...mapGetters(["tags"]),
        translatedFields() {
            return [
                { key: 'unit_no', label: this.$t('maintenanceLineItems.unitColumn'), stickyColumn: true, sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'tags', label: this.$t('maintenanceLineItems.tagsColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'date', label: this.$t('maintenanceLineItems.dateColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'record_no', label: this.$t('maintenanceLineItems.recordColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'description', label: this.$t('maintenanceLineItems.descriptionColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'maintenance_category', label: this.$t('maintenanceLineItems.repairCategoryColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'item_type', label: this.$t('maintenanceLineItems.typeColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'quantity', label: this.$t('maintenanceLineItems.qtyColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'rate', label: this.$t('maintenanceLineItems.rateColumn'), sortable: true, thClass: 'font-table-weight-bold' },
                { key: 'amount', label: this.$t('maintenanceLineItems.amountColumn'), sortable: true, thClass: 'font-table-weight-bold' },
            ];
        },
        shortcuts() {
            const make = (text, fn) => ({ text, onClick: fn });
            return [
                make(this.$t('datepickerShortcuts.thisWeek'), () => {
                    const today = new Date();
                    const dayOfWeek = today.getDay() || 7;
                    const startOfWeek = new Date(today);
                    startOfWeek.setDate(today.getDate() - dayOfWeek + 1);
                    this.filterFields.date = [startOfWeek, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.thisMonth'), () => {
                    const today = new Date();
                    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                    this.filterFields.date = [startOfMonth, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.thisYear'), () => {
                    const today = new Date();
                    const startOfYear = new Date(today.getFullYear(), 0, 1);
                    this.filterFields.date = [startOfYear, today];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastWeek'), () => {
                    const today = new Date();
                    const dayOfWeek = today.getDay() || 7;
                    const startOfLastWeek = new Date(today);
                    startOfLastWeek.setDate(today.getDate() - dayOfWeek - 6);
                    const endOfLastWeek = new Date(today);
                    endOfLastWeek.setDate(today.getDate() - dayOfWeek);
                    this.filterFields.date = [startOfLastWeek, endOfLastWeek];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastMonth'), () => {
                    const today = new Date();
                    const startOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    const endOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
                    this.filterFields.date = [startOfLastMonth, endOfLastMonth];
                    this.getTableData();
                }),
                make(this.$t('datepickerShortcuts.lastYear'), () => {
                    const today = new Date();
                    const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1);
                    const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31);
                    this.filterFields.date = [startOfLastYear, endOfLastYear];
                    this.getTableData();
                }),
            ];
        },
    },
    watch: {
        perPage: {
            async handler() {
                await this.getTableData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getTableData();
            },
        },
        sortBy: {
            async handler() {
                await this.getTableData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getTableData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
        company: {
            async handler() {
                await this.getAllTags(this.userCompany);
                this.tags.map((item) => {
                    this.allTags.push({
                        id: item.add_tag,
                        label: item.add_tag,
                    });
                });
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        ...mapActions(["getAllMaintenaceLineItems", "getAllTags", "getMaintenaceLineItemFilters", "getFilteredEquipments"]),
        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async getTableData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if ((key === "tags" || key === "units" || key === 'categories' || key === 'item_types') && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date' && this.filterFields['date'][0]) {
                        url += `start_date=${moment(this.filterFields['date'][0]).format("YYYY-MM-DD")}&end_date=${moment(this.filterFields['date'][1]).format("YYYY-MM-DD")}&`
                    }
                    else if (this.filterFields[key] !== '' && key !== 'tags' && key !== 'date' && key !== 'units' && key !== 'categories' && key !== 'item_types') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=unit_no&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getAllMaintenaceLineItems(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('reportsCommon.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('reportsCommon.emptyPosition')
                }
                data.records.map((item) => {
                    const tableItem = {}
                    Object.keys(item).map((key) => {
                        if (key === "date") tableItem[key] = item[key] ? moment(item[key]).format("ll") : "-"
                        else if (key === "tags") tableItem[key] = item[key]
                        else
                            if (item[key]) tableItem[key] = item[key]
                            else tableItem[key] = "-"
                    })
                    this.items.push(tableItem)
                })
                this.totalAmount = data.total_amount
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isTableMounted = true
                this.isBusy = false
                console.log(e)
            }
        },
        async searchUnits(searchText) {
            if (searchText) {
                let options = [];
                const records = await this.getFilteredEquipments({ unit_no: searchText });
                records.forEach((x) => {
                    options.push({
                        id: `${x.unit_no}`,
                        label: `${x.unit_no}`,
                    });
                });

                // Merge and deduplicate by `id`
                this.allUnits = [
                    ...new Map(
                        [...this.allUnits, ...options].map(item => [item.id, item])
                    ).values()
                ];

            }
        },
    },
    async mounted() {
        this.filtersData = await this.getMaintenaceLineItemFilters()
    }
}
</script>
<style>
.date-picker-custom.f-12 .mx-input-wrapper .mx-input {
    font-size: 12px !important;
}

</style>